module.exports = __webpack_public_path__ + "img/logo.ac322d8b.png";